module.exports = __webpack_public_path__ + "static/screenshot6-min.277d5593.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/screenshot6-min.png
// module id = 464
// module chunks = 35783957827783